<h1 mat-dialog-title>Who Are We? </h1>
<div id="footer-who-section-content" mat-dialog-content>
    Machinify has served health plans across the nation since 1985, and we are a trusted business partner of your health plan.
    We review health care claims to ensure that the correct insurer or entity pays those claims according to the terms of the health plan
    as well as applicable state and federal laws. We provide all of our services by treating others with respect, integrity, and compassion,
    and we look forward to working with you.
</div>
<div id="footer-who-section-content" class="action-button-container" mat-dialog-actions align="end">
    <button id="footer-who-button-close" mat-flat-button mat-dialog-close color="accent">Close</button>
    <button id="footer-who-button-primary" mat-flat-button [color]="'primary'" (click)="OnClickLearnMore()">Learn More</button>
</div>
